import { render, staticRenderFns } from "./InspectionListProcessAlfaberries.vue?vue&type=template&id=6bd7c2e0&"
import script from "./InspectionListProcessAlfaberries.vue?vue&type=script&lang=js&"
export * from "./InspectionListProcessAlfaberries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports